import axios from 'axios'

import { getAlertData } from '../config/alert'

const _sendMessage = async data => {
    const BOA_ENDPOINT = import.meta.env.VITE_BOA_ENDPOINT
    const url = `${BOA_ENDPOINT}misc/alert`
    try {
        await axios.post(url, data)
    } catch (error) {
        console.error('Failed to send alert: ', error)
    }
}

const sendAlertMessage = async data => {
    const alertData = data.type ? getAlertData(data) : null
    if (!alertData) return
    await _sendMessage(alertData)
}

export { sendAlertMessage }
